'use client'

import { Button, Code, Container, Paper, Stack, Text, Title } from '@mantine/core'

interface ErrorStateProps {
    title?: string
    description?: string
    digest?: string
    reset?: () => void
    homeHref?: string
}

export default function ErrorState({
    title = 'Something went wrong',
    description = 'Please try again. If the problem continues, contact support.',
    digest,
    reset,
    homeHref = '/'
}: ErrorStateProps) {
    return (
        <Container size='sm' py='xl'>
            <Paper withBorder radius='md' p='xl'>
                <Stack gap='md' align='flex-start'>
                    <Stack gap={4}>
                        <Title order={1}>{title}</Title>
                        <Text c='dimmed'>{description}</Text>
                    </Stack>

                    {digest && (
                        <Text size='sm' c='dimmed'>
                            Error reference: <Code>{digest}</Code>
                        </Text>
                    )}

                    <Stack gap='xs'>
                        {reset && <Button onClick={reset}>Try again</Button>}
                        <Button component='a' href={homeHref} variant='light'>
                            Go home
                        </Button>
                    </Stack>
                </Stack>
            </Paper>
        </Container>
    )
}
